export default "__VITE_ASSET__Df779IJE__"